/**
 * Module-level Clerk appearance config shared by SignUp and SignIn.
 *
 * Must be a stable reference (not constructed inline in JSX) — Clerk
 * re-instantiates the widget when `appearance` changes object identity,
 * which on the signup flow causes duplicate verification emails. Import
 * this constant; never spread it into a new object at the call site.
 */

const PRIMARY_600 = '#4f46e5'
const PRIMARY_700 = '#4338ca'
const GRAY_900 = '#111827'
const GRAY_700 = '#374151'
const GRAY_300 = '#d1d5db'
const GRAY_200 = '#e5e7eb'
const GRAY_50 = '#f9fafb'

export const clerkAppearance = {
  variables: {
    colorPrimary: PRIMARY_600,
    colorTextOnPrimaryBackground: '#ffffff',
    colorBackground: '#ffffff',
    colorText: GRAY_900,
    colorTextSecondary: GRAY_700,
    colorInputBackground: '#ffffff',
    colorInputText: GRAY_900,
    borderRadius: '0.5rem',
    fontFamily: 'inherit',
    fontSize: '0.9375rem',
  },
  elements: {
    rootBox: {
      width: '100%',
    },
    card: {
      width: '100%',
      maxWidth: '100%',
      boxShadow: 'none',
      border: 'none',
      backgroundColor: 'transparent',
      padding: 0,
    },
    cardBox: {
      boxShadow: 'none',
      border: 'none',
      width: '100%',
    },
    header: {
      display: 'none',
    },
    headerTitle: {
      display: 'none',
    },
    headerSubtitle: {
      display: 'none',
    },
    socialButtonsBlockButton: {
      borderColor: GRAY_300,
      backgroundColor: '#ffffff',
      color: GRAY_900,
      fontWeight: 500,
      '&:hover': {
        backgroundColor: GRAY_50,
        borderColor: GRAY_300,
      },
    },
    socialButtonsBlockButtonText: {
      fontWeight: 500,
    },
    dividerLine: {
      backgroundColor: GRAY_200,
    },
    dividerText: {
      color: GRAY_700,
    },
    formFieldLabel: {
      color: GRAY_900,
      fontWeight: 500,
    },
    formFieldInput: {
      borderColor: GRAY_300,
      '&:focus': {
        borderColor: PRIMARY_600,
        boxShadow: `0 0 0 3px ${PRIMARY_600}25`,
      },
    },
    formButtonPrimary: {
      backgroundColor: PRIMARY_600,
      fontSize: '0.9375rem',
      fontWeight: 600,
      textTransform: 'none',
      boxShadow: 'none',
      height: '2.75rem',
      '&:hover': {
        backgroundColor: PRIMARY_700,
      },
      '&:focus': {
        boxShadow: `0 0 0 3px ${PRIMARY_600}40`,
      },
    },
    footer: {
      display: 'none',
    },
    footerAction: {
      display: 'none',
    },
    identityPreviewEditButton: {
      color: PRIMARY_600,
    },
    formFieldAction: {
      color: PRIMARY_600,
    },
    formResendCodeLink: {
      color: PRIMARY_600,
    },
  },
}
